<template>
   <div>
      <div class="row mb-4">
         <div class="col">
            <div class="card border-left-warning shadow h-100 py-2">
               <div class="card-body">
                  <form action="" @submit.prevent="getData">
                     <div class="row">
                        <div class="col">
                           <div class="row">
                              <div class="col">
                                 <select class="form-control" v-model="year" aria-placeholder="السنة">
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                 </select>
                              </div>
                              <div class="col">
                                 <select class="form-control" v-model="month" aria-placeholder="الشهر">
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                 </select>
                              </div>
                           </div>
                        </div>
                        <div class="col-auto">
                           <button type="submit" class="btn btn-success">
                              <i class="fas fa-search"></i>
                           </button>
                        </div>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>

      <div class="row" v-if="loading">
         <div class="col">
            <div class="big-loader text-center pt-50 pb-50">
               <loader />
            </div>
         </div>
      </div>

      <div class="row mb-5 justify-content-center" v-if="!loading">
         <div class="col-4">
            <div class="card border-left-danger shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
                              عمولات مستحقة لإزهلها على الفزاعين
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.commissions }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-ban fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-4">
            <div class="card border-left-danger shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
                              عمولات مستحقة لإزهلها اعلى من 50 ريال
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.commissions_over_50 }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-comment-dollar fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="row mb-5">
         <div class="col">
            <div class="card border-left-success shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                              قيمة الخدمات
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.service_cost }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-truck fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>
         
         <div class="col">
            <div class="card border-left-success shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                              قيمة كوبونات الخصم
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.discount }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-tags fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>

         <div class="col">
            <div class="card border-left-success shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                              قيمة الضرائب
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.taxed_amount }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-hand-holding-usd fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="row mb-5">
         <div class="col">
            <div class="card border-left-success shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                              قيمة المشتريات
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.items_cost }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>

         <div class="col">
            <div class="card border-left-success shadow py-2">
               <div class="card-body">
                  <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                           <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                              اجمالي المدفوعات
                           </div>
                           <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.total_price }} ريال</div>
                        </div>
                        <div class="col-auto">
                           <i class="fas fa-coins fa-2x text-gray-300"></i>
                        </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="card shadow mb-4" v-if="!loading">
         <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">تقرير المالية</h6>
         </div>

         <div class="card-body">
            <div class="row mb-5">
               <div class="col">
                  <DataTable
                     title="طرق الدفع"
                     :columns="tableColums"
                     :rows="data.payment_method"
                     :exportable="false"
                     v-if="data.payment_method"
                  />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import DataTable from "vue-materialize-datatable";

   export default 
   {
      name: "AccountingReport",
      components: {
         DataTable
      },
      data(){
         return {
            loading: true,
            breadcrum: {
               "/": "الرئيسية",
               "#": "تقرير المالية",
            },
            year: "",
            month: "",
            data: {},
            chartOption: {
               responsive: true,
               maintainAspectRatio: false
            },
            tableColums: [
               {
                  label: "طريقة الدفع",
                  field: "name",
                  numeric: false,
                  html: false
               },
               {
                  label: "قيمة الخدمة",
                  field: "service_cost",
                  numeric: true,
                  html: false
               },
               {
                  label: "قيمة الضريبة",
                  field: "taxed_amount",
                  numeric: true,
                  html: false
               },
               {
                  label: "قيمة المشتريات",
                  field: "items_cost",
                  numeric: true,
                  html: false
               },
               {
                  label: "القيمة الإجمالية",
                  field: "total_price",
                  numeric: true,
                  html: false
               },
            ],
         }
      },
      methods: {
         getData(){
            this.loading = true;
            this.$store.commit("SET_ERROR", "");
            this.$http.get("/api/reports/accounting/" + this.year + this.month).then(response => {
               this.loading = false;
               this.data = response.data;
            }).catch(err => {
               this.$store.commit("SET_ERROR", err.data.error);
            });
         },
      },
      created(){
         this.$store.commit("SET_ACTIVE_MENU", "accounting_report");
         this.$store.commit("SET_BREADCRUMB", this.breadcrum);
         this.$store.commit("SET_ERROR", "");
         this.$store.commit("SET_SUCCESS", "");
         this.$store.commit("SET_TITLE", "تقرير المالية");
         
         let date = new Date();
         this.year = date.getFullYear();
         if(date.getMonth() < 10){
            this.month = `0${date.getMonth()+1}`;
         }else{
            this.month = date.getMonth()+1;
         }
         
         this.getData();
      }
   }
</script>